// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1as6e","clinicsSelect":"TableHeading_clinicsSelect__AJiPe"};